import { FC } from "react";
import { Controller, ControllerProps, useFormContext } from "react-hook-form";

export type HFormFieldProps = {
  name: string;
  renderField: ControllerProps["render"];
  controllerProps?: Partial<ControllerProps>;
};

const HFormField: FC<HFormFieldProps> = ({
  name,
  renderField,
  controllerProps,
}) => {
  const { control, formState } = useFormContext();
  const defaultValue = formState?.defaultValues?.[name];
  return (
    <Controller
      name={name}
      control={control}
      render={renderField}
      {...controllerProps}
      defaultValue={defaultValue || ""}
    />
  );
};

export { HFormField };
